
import {defineComponent} from "vue";
import './PasswordGenerator.scss'
import './Modal.scss'
import CopiedModal from "@/components/CopiedModule.vue";
import {generatePassword, PasswordSettings} from "@/passwordGenerator";

function GetPasswordDifficulty(score: number) {
  switch (score){
    case 1: return 'MINIMAL';
    case 2: return 'LOW';
    case 3: return 'NORMAL';
    case 4: return 'HIGH';
  }
  return 'NONE';
}

export default defineComponent({
  name: 'PasswordGenerator',
  components: {CopiedModal},
  data() {
    return {
      password: 'Y3@fR5$r',
      passwordLength: 4,
      addUpperLetters: false,
      addLowerLetters: true,
      addNumbers: false,
      addSymbols: true,
      copyModal: false,
      passwordDifficulty: 'NONE',
      passwordScore: 0,
      passwordCreated: false,
    }
  },
  methods: {
    showCopyModal: function (){
      navigator.clipboard.writeText(this.password);
      this.copyModal = !this.copyModal;
    },
    generate: function () {
      const settings = new PasswordSettings();
      settings.length = this.passwordLength;
      settings.uppercase = this.addUpperLetters;
      settings.lowercase = this.addLowerLetters;
      settings.numbers = this.addNumbers;
      settings.symbols = this.addSymbols;
      const generatedString = generatePassword(settings);
      this.password = generatedString.password;
      this.passwordScore = generatedString.score;
      this.passwordDifficulty = GetPasswordDifficulty(this.passwordScore);
      this.passwordCreated = true;
    }
  }
})
